export default __webpack_public_path__ + "static/limpol-f261ee76f20f75d02a55163a9db68560.jpg";